import { render, staticRenderFns } from "./ScreenLaudoViloCorial.vue?vue&type=template&id=09873547&lang=true&"
import script from "./ScreenLaudoViloCorial.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoViloCorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports